export default __webpack_public_path__ + "static/media/logo-rappi.bf05f8d4.svg";